import React from "react";
import { useTranslation } from "react-i18next";
import CommonLayout from "../CommonLayout";
import "./index.css";

const PrivacyAndPolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CommonLayout
      title={t("lblPrivacyAndPolicy")}
      showBackButton={true}
    >
      <div className="privacyPolicyPage">
        <iframe
          className="privacyPolicyIframe"
          src="https://www.ink-aa.com/privacy-policy.html"
          title={t("lblPrivacyAndPolicy")}
          frameBorder="0"
        />
      </div>
    </CommonLayout>
  );
};

export default PrivacyAndPolicy;